export const FETCH_DICTIONARY_LIST_SUCCESS = 'MEMBER_PORTAL/FETCH_DICTIONARY_LIST_SUCCESS';
export const FETCH_DICTIONARY_LIST_LOADING = 'MEMBER_PORTAL/FETCH_DICTIONARY_LIST_LOADING';
export const RESET_DICTIONARY_LIST = 'MEMBER_PORTAL/RESET_DICTIONARY_LIST';
